export default __webpack_public_path__ + "static/media/idea.3045c6af.svg";